import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable()
export class AppLoadService {
  helper = new JwtHelperService();
  constructor() {}

  checkTokenExpiry(): Promise<void> {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("jwt");
      if (token) {
        if (this.helper.isTokenExpired(token)) {
          localStorage.removeItem("jwt");
        }
      } else {
        console.log(`checkTokenExpiry:: Token is not there`);
      }
      resolve();
    });
  }
}
